import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel, RadioGroup as MUIRadioGroup } from '@mui/material';

import { FormControl } from '../formControl/FormControl';
import RadioButton, { Radio } from './RadioButton';

export const RadioGroup = props => {
  const { label = '', ...data } = props;

  if (!label) {
    return <MUIRadioGroup {...data} />;
  }

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <MUIRadioGroup {...data} />
    </FormControl>
  );
};

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any   // eslint-disable-line react/forbid-prop-types
};

RadioGroup.RadioButton = RadioButton;
RadioGroup.Radio = Radio;

export { Radio };
export default RadioGroup;
